<template>
  <div class="content">
    <div class="inner_content">
      <div class="zhifubao-top">
        <div class="flex" style="margin-right: 30px">
          <div>支付宝：</div>
          <el-input
            v-model="alipay_userid"
            placeholder="请输入userID"
            class="flxedWidth"
          ></el-input>
          <el-button type="plarmy" @click="setId(0)">确定</el-button>
        </div>

        <div>
          <img src="@public/img/pay/userId.png" alt="" class="flxedWidth" />
          <div class="explain">
            支付宝扫描以下二维码查看userid
          </div>
        </div>
      </div>
      <el-table
        :data="zhifubaoList"
        size="small"
        :header-cell-style="setHeader"
        style="margin-top: 25px;"
      >
        <el-table-column
          prop="alipay_userid"
          label="支付宝userID"
        ></el-table-column>
        <el-table-column prop="time" label="上传时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <el-button @click="setId(1)">编辑</el-button>
          <el-button>修改</el-button>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { zhifubaoList, zhifubaoSet } from "@/api/pay";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      alipay_userid: "",
      activeName: "0",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      zhifubaoList: [],
      amend: ""
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    go(path) {
      console.log("path", path);
      this.$router.push(path);
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    // zhifubao
    getList() {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id
        // page: this.page,
      };
      zhifubaoList(data).then(res => {
        console.log("订单列表", res);
        if (res.code == 200) {
          var obj = {
            alipay_userid: res.data.alipay_userid,
            time: res.data.create_time
          };
          this.zhifubaoList.push(obj);
        }
      });
    },
    // 设置
    setId(jude) {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      if (jude) {
        this.$prompt("请输入修改ID", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(({ value }) => {
            data.alipay_userid = value;
            zhifubaoSet(data).then(res => {
              console.log("设置数据", res);
              if (res.code == 200) {
                this.$message.success("修改成功");
                this.reload();
              } else {
                this.$message(res.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
            return;
          });
      } else {
        if (!this.alipay_userid) {
          this.$message("请输入userID");
          return false;
        }
        data.alipay_userid = this.alipay_userid;
        zhifubaoSet(data).then(res => {
          console.log("设置数据", res);
          if (res.code == 200) {
            this.$message.success("添加成功");
          } else {
            this.$message(res.msg);
          }
          // this.tableData = res.data.result;
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 24px 24px 0;
    height: 100%;
    .el-tabs {
      height: 100%;
      position: relative;
      .el-pagination {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .el-card {
      width: 250px;
      height: 329px;
      margin: 0 15px 15px 0px;
    }
    .zhifubao-top {
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0px;
}
.flxedWidth {
  width: 140px;
}
.color-red {
  color: red;
  padding-right: 10px;
}
.color-blue {
  color: #409eff;
}
// 卡片样式
.explain {
  line-height: 30px;
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
